module.exports = __webpack_public_path__ + "img/GALLERY-S-CROSS-2.4b8796c8.jpg";